( function( window, document, $ ) {
    'use strict';

    $( document ).ready( function() {
        // --------------------------------------------------
        // DEFINE FUNCTIONS
        // --------------------------------------------------
        function init() {
            var sliderElem = $( '.js--teachings-slider' );
            var sliderCopy = $( '.js--teachings-copy-dest' );

            if ( $.fn.slick !== undefined && sliderElem.length && sliderCopy.length ) {
                sliderElem.slick( {
                    slidesToShow: 1,
                    centerMode: true,
                    focusOnSelect: true,
                    centerPadding: '200px',
                    variableWidth: true,
                    lazyLoad: 'progressive',
                } );

                sliderElem.on( 'afterChange', function( event, slick, currentSlide ) {
                    var teachingContent = sliderElem.find( '[data-slick-index="' + currentSlide + '"]' ).find( '.js--teachings-copy-src' ).html();

                    sliderCopy.html( teachingContent );
                } );
            }
        }

        // --------------------------------------------------
        // INIT
        // --------------------------------------------------
        init();

        if ( typeof Barba !== 'undefined' && typeof Barba.Dispatcher === 'object' ) {
            Barba.Dispatcher.on( 'transitionCompleted', function() {
                init();
            } );
        }

    } );
} )( window, document, jQuery );
